import {RemoveAction} from '@wandb/weave/components/Tag';
import React from 'react';

import {FilterTag} from '../../../../filters/FilterTag';
import {ScoreFilter} from './ScoreFilterPopover';

type GroupedScoreOption = {
  label: string;
  options: Array<{value: string; label: string}>;
};

type ScoreFilterTagItemProps = {
  filter: ScoreFilter;
  availableScoreKeys: GroupedScoreOption[];
  onRemoveFilter: (id: string | number) => void;
  onClick?: () => void;
};

const getOperatorLabel = (operatorValue: string): string => {
  const operatorMap: {[key: string]: string} = {
    '(number): =': '=',
    '(number): !=': '≠',
    '(number): <': '<',
    '(number): <=': '≤',
    '(number): >': '>',
    '(number): >=': '≥',
  };
  return operatorMap[operatorValue] || operatorValue;
};

const getScoreLabel = (
  scoreKey: string,
  availableScoreKeys: GroupedScoreOption[]
): string => {
  for (const group of availableScoreKeys) {
    const found = group.options.find(k => k.value === scoreKey);
    if (found) {
      return found.label;
    }
  }
  return scoreKey;
};

export const ScoreFilterTagItem: React.FC<ScoreFilterTagItemProps> = ({
  filter,
  availableScoreKeys,
  onRemoveFilter,
  onClick,
}) => {
  const scoreLabel = getScoreLabel(filter.scoreKey, availableScoreKeys);
  const operatorLabel = getOperatorLabel(filter.operator);

  return (
    <FilterTag
      label={
        <>
          {scoreLabel} {operatorLabel}
          <span className="ml-4">{filter.value}</span>
        </>
      }
      isEditing={false}
      onClick={onClick}
      removeAction={
        <RemoveAction
          onClick={(e: any) => {
            e.stopPropagation();
            onRemoveFilter(filter.id);
          }}
        />
      }
    />
  );
};
